import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

/** 네이티브 date/time 계열 타입 — Chromium showPicker() 대상 */
const PICKER_TYPES = new Set([
  'date',
  'datetime-local',
  'time',
  'month',
  'week',
]);

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, type, onClick, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-10 w-full rounded-lg border bg-[var(--color-surface)] px-3 py-2 text-sm',
        'placeholder:text-[var(--color-text-sub)]',
        'focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)]/40',
        'disabled:cursor-not-allowed disabled:opacity-50',
        error ? 'border-[var(--color-rise)]' : 'border-[var(--color-border)]',
        className,
      )}
      onClick={(e) => {
        /* 날짜/시간 계열은 입력창 아무 곳이나 클릭해도 피커가 열리게.
           일부 브라우저(Chromium 계열 일부 버전)는 showPicker 미지원 → optional chain */
        if (type && PICKER_TYPES.has(type)) {
          const el = e.currentTarget as HTMLInputElement & { showPicker?: () => void };
          try {
            el.showPicker?.();
          } catch {
            /* user interaction 부족 등으로 실패해도 무시 — 기본 동작으로 폴백 */
          }
        }
        onClick?.(e);
      }}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
